import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "truncate",
})
export class TruncatePipe implements PipeTransform {
    transform(
        value: string | null | undefined,
        limit: number = 25,
        ellipsis: string = "...",
    ): string {
        if (!value) {
            return "";
        }

        if (value.length <= limit) {
            return value;
        }

        let truncated = value.substring(0, limit);
        return truncated + ellipsis;
    }
}
